/* ULMO REDESIGN — PDP STICKY BAR v25.
   v24 still wasn't pinning because an ancestor of .product-buy-buttons-wrapper
   creates a new "containing block" (via transform/filter/perspective/will-change),
   which traps position:fixed and makes it position relative to that ancestor
   instead of the viewport. This is why even Luxe's built-in .sticky-buy-buttons
   sticky CSS doesn't actually pin to the viewport on this page.

   v25 fix: physically reparent .product-buy-buttons-wrapper to be a direct child
   of <body>, escaping any containing block. Then position:fixed works against
   the viewport regardless of what ancestor CSS does.

   The <product-form> custom element's variant change / add-to-cart behavior is
   self-contained — moving its DOM location does not break submission logic.
*/
(function() {
  if (window.__uPdpStickyBarV25) return;
  window.__uPdpStickyBarV25 = true;

  var mq = window.matchMedia('(max-width: 749px)');
  var movedToBody = false;

  function setStyles(el, styles) {
    if (!el) return;
    Object.keys(styles).forEach(function(prop) {
      try { el.style.setProperty(prop, styles[prop], 'important'); } catch(e) {}
    });
  }

  function pin() {
    if (!mq.matches) return;

    var wrapper = document.querySelector('.product-buy-buttons-wrapper');
    if (wrapper) {
      /* === V25 ROOT-CAUSE FIX === */
      if (!movedToBody && wrapper.parentElement !== document.body) {
        wrapper.dataset.uOriginalParent = 'reparented';
        document.body.appendChild(wrapper);
        movedToBody = true;
      }

      setStyles(wrapper, {
        'position': 'fixed',
        'bottom': '0',
        'left': '0',
        'right': '0',
        'z-index': '100',
        'width': '100%',
        'margin': '0',
        'box-sizing': 'border-box',
        'padding': '14px 16px calc(14px + env(safe-area-inset-bottom, 0px))',
        'background': 'rgba(255, 255, 255, 0.62)',
        'backdrop-filter': 'blur(28px) saturate(1.8)',
        '-webkit-backdrop-filter': 'blur(28px) saturate(1.8)',
        'border-top': '1px solid rgba(255, 255, 255, 0.55)',
        'box-shadow': '0 -8px 32px rgba(0, 0, 0, 0.08)',
        'transform': 'none'
      });

      setStyles(wrapper.querySelector('product-form, .product-form'), {
        'display': 'block',
        'position': 'static',
        'background': 'transparent',
        'padding': '0',
        'margin': '0',
        'box-shadow': 'none',
        'width': '100%'
      });
      setStyles(wrapper.querySelector('form, .form'), {
        'display': 'block',
        'margin': '0',
        'padding': '0'
      });

      var buttons = wrapper.querySelector('.product-form__buttons');
      if (buttons) {
        setStyles(buttons, {
          'display': 'grid',
          'grid-template-columns': '1fr 1fr',
          'grid-template-rows': '48px auto',
          'column-gap': '10px',
          'row-gap': '6px',
          'margin': '0',
          'padding': '0',
          'align-items': 'stretch',
          'width': '100%'
        });

        var submit = buttons.querySelector('.product-form__submit');
        setStyles(submit, {
          'grid-column': '1',
          'grid-row': '1',
          'width': '100%',
          'height': '48px',
          'min-height': '48px',
          'max-height': '48px',
          'margin': '0',
          'padding': '0 12px',
          'border-radius': '24px',
          'box-sizing': 'border-box',
          'display': 'inline-flex',
          'align-items': 'center',
          'justify-content': 'center'
        });

        var moreOptions = buttons.querySelector('.shopify-payment-button__more-options');
        if (moreOptions && moreOptions.parentElement !== buttons) {
          buttons.appendChild(moreOptions);
        }

        var pay = buttons.querySelector('.shopify-payment-button');
        if (pay) {
          setStyles(pay, {
            'grid-column': '2',
            'grid-row': '1',
            'width': '100%',
            'height': '48px',
            'min-height': '48px',
            'max-height': '48px',
            'margin': '0',
            'padding': '0',
            'overflow': 'hidden',
            'border-radius': '24px',
            'display': 'block'
          });

          var dataShopify = pay.querySelector('[data-shopify="dynamic-checkout-cart"]');
          setStyles(dataShopify, {
            'height': '48px',
            'margin': '0',
            'padding': '0',
            'display': 'block'
          });

          var innerBtn = pay.querySelector(
            'shop-pay-wallet-button, ' +
            '.shopify-payment-button__button, ' +
            '[class*="shopify-payment-button__button--branded"]'
          );
          setStyles(innerBtn, {
            'height': '48px',
            'min-height': '48px',
            'max-height': '48px',
            'width': '100%',
            'margin': '0',
            'border-radius': '24px'
          });
        }

        if (moreOptions) {
          setStyles(moreOptions, {
            'grid-column': '1 / -1',
            'grid-row': '2',
            'display': 'block',
            'width': '100%',
            'text-align': 'center',
            'margin': '0 auto',
            'padding': '2px 0 0',
            'white-space': 'nowrap',
            'font-size': '12px',
            'line-height': '1.4',
            'background': 'transparent',
            'border': 'none',
            'color': 'inherit'
          });
        }
      }

      setStyles(document.getElementById('MainContent'), { 'padding-bottom': '150px' });
    }

    /* Attributes row */
    var attrs = document.querySelector('.u-pdp-attributes');
    if (attrs) {
      setStyles(attrs, {
        'display': 'flex',
        'flex-wrap': 'nowrap',
        'white-space': 'nowrap',
        'gap': '6px',
        'align-items': 'center',
        'justify-content': 'flex-start',
        'overflow-x': 'hidden',
        'width': '100%',
        'max-width': '100%',
        'box-sizing': 'border-box',
        'font-size': '10px',
        'letter-spacing': '0.06em'
      });
      Array.prototype.forEach.call(attrs.querySelectorAll('span'), function(s) {
        s.style.setProperty('white-space', 'nowrap', 'important');
        s.style.setProperty('flex', '0 0 auto', 'important');
        s.style.setProperty('font-size', 'inherit', 'important');
        s.style.setProperty('letter-spacing', 'inherit', 'important');
      });
    }

    /* Hero buttons */
    var heroRow = document.querySelector('.u-redesign-hero--has-mobile .image-banner-buttons-inline');
    if (heroRow) {
      heroRow.style.setProperty('justify-content', 'flex-start', 'important');
      heroRow.style.setProperty('gap', '10px', 'important');
      Array.prototype.forEach.call(heroRow.children, function(c) {
        c.style.setProperty('margin-left', '0', 'important');
        c.style.setProperty('margin-right', '0', 'important');
      });
      var lm = heroRow.querySelector('.link--underlined');
      if (lm) {
        lm.style.setProperty('font-size', '13.5px', 'important');
        lm.style.setProperty('letter-spacing', '0.10em', 'important');
      }
      var sn = heroRow.querySelector('.button.button--solid');
      if (sn) {
        sn.style.setProperty('font-size', '14px', 'important');
        sn.style.setProperty('letter-spacing', '0.12em', 'important');
      }
    }
  }

  function ready() {
    pin();
    [100, 400, 1000, 2500, 5000, 10000].forEach(function(delay) {
      setTimeout(pin, delay);
    });
    if (window.MutationObserver && document.body) {
      var obs = new MutationObserver(pin);
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function() { obs.disconnect(); }, 20000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();

/* ============================================================
   Added Oct 22, 2026: small superscript ® in the product title.
   Wraps each ® in .product__title headings in <sup class="u-reg">
   so redesign-pdp-info-bento.css (v25) can size it. The title text
   itself is unchanged (still "Ulmo Honey®"). All viewports.
   ============================================================ */
;(function() {
  if (window.__uPdpRegMark) return;
  window.__uPdpRegMark = true;

  function supReg() {
    var heads = document.querySelectorAll('.product__title h1, .product__title h2');
    Array.prototype.forEach.call(heads, function(h) {
      if (h.getAttribute('data-u-reg') === '1') return;
      var walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT, null, false);
      var nodes = [];
      var n;
      while ((n = walker.nextNode())) {
        if (n.nodeValue.indexOf('®') > -1 && !(n.parentNode && n.parentNode.nodeName === 'SUP')) nodes.push(n);
      }
      nodes.forEach(function(t) {
        var parts = t.nodeValue.split('®');
        var frag = document.createDocumentFragment();
        parts.forEach(function(p, i) {
          if (p) frag.appendChild(document.createTextNode(p));
          if (i < parts.length - 1) {
            var s = document.createElement('sup');
            s.className = 'u-reg';
            s.textContent = '®';
            frag.appendChild(s);
          }
        });
        t.parentNode.replaceChild(frag, t);
      });
      h.setAttribute('data-u-reg', '1');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', supReg);
  } else {
    supReg();
  }
})();

/* ============================================================
   Added Oct 22, 2026: Read more for the product description on
   phones. Adds a toggle button after the description; the collapse
   itself is CSS (redesign-pdp-info-bento.css v26, max-width 749px),
   so on larger screens the button stays hidden and the text shows
   in full. The full text stays in the page for SEO and screen
   readers. Skipped for short descriptions.
   ============================================================ */
;(function() {
  if (window.__uPdpDescToggle) return;
  window.__uPdpDescToggle = true;

  function setupDescToggle() {
    var desc = document.querySelector('.product__info-container .product-description-standard');
    if (!desc || desc.getAttribute('data-u-desc') === '1') return;
    if (!desc.textContent || desc.textContent.trim().length < 280) return;
    desc.setAttribute('data-u-desc', '1');
    if (!desc.id) desc.id = 'productDescriptionTxt';
    desc.classList.add('u-desc-collapsible');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'u-desc-toggle';
    btn.setAttribute('aria-controls', desc.id);
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read more';
    desc.insertAdjacentElement('afterend', btn);
    btn.addEventListener('click', function() {
      var open = desc.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Read less' : 'Read more';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDescToggle);
  } else {
    setupDescToggle();
  }
})();
